/* TundraLegs BOGO cart rows — remove a whole size at once.

   In the drawer a TundraLegs size is drawn as ONE row ("2 sets · 1 free")
   even when Shopify split it into a paid line and a free line. The row's
   trash button therefore carries every line key of that size
   (data-wg-remove-keys="key1,key2"); this removes them in one /cart/update
   call and hands the re-rendered section to Horizon's cart component the
   same way its own remove does (see assets/tundra-cart.js for the add). */

import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('click', async (e) => {
  const btn = e.target.closest && e.target.closest('[data-wg-remove-keys]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();

  const keys = String(btn.dataset.wgRemoveKeys || '').split(',').filter(Boolean);
  if (!keys.length) return;

  const component = btn.closest('cart-items-component');
  const sectionId = component && component.dataset.sectionId;
  const row = btn.closest('.cart-items__table-row');
  if (row) row.classList.add('removing');
  btn.disabled = true;

  const updates = {};
  keys.forEach((k) => { updates[k] = 0; });

  let res;
  try {
    res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections: sectionId, sections_url: window.location.pathname }),
    }).then((r) => r.json());
  } catch (err) {
    btn.disabled = false;
    if (row) row.classList.remove('removing');
    return;
  }

  const deferred = CartLinesUpdateEvent.createPromise();
  const event = new CartLinesUpdateEvent({
    action: 'remove',
    context: 'cart',
    lines: keys.map((id) => ({ id, quantity: 0 })),
    promise: deferred.promise,
  });
  document.dispatchEvent(event);
  deferred.resolve({
    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(res),
    detail: {
      sections: res.sections,
      items: res.items,
      itemCount: res.item_count,
      source: 'cart-items-component',
      didError: false,
    },
  });
});
